<template>
  <div class="max-w-full">
    <div>
      <label class="font-semibold text-base mb-2 flex items-center">
        {{ $t('frontend_groovemail_send_test_email_label')}} 
      </label>
    </div>
    <div class="flex flex-col gap-2 sm:flex-row justify-between">
      <div class="sm:w-5/6">
        <text-input
          class="pr-8"
          variant="base"
          v-model="recipientEmail"
          :validator="$v.recipientEmail"
          :placeholder="this.$t('frontend_groovemail_admin_settings_enter_email')"
        />
      </div>
      <div>
        <gd-button
          class="w-full sm:w-auto"
          size="auto"
          variant="primary"
          @click="proceedsendingTestEmail()"
        >
          {{ $t('frontend_send') }}
        </gd-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig';

export default {
  name: 'send-test-email',

  data() {
    return {
      recipientEmail: '',
    };
  },

  validations: {
    recipientEmail: {
      required,
      email,
      minLength: minLength(3),
      maxLength: maxLength(50),
    },
  },

  methods: {
    proceedsendingTestEmail() {
      this.$v.recipientEmail.$touch();
      if (!this.$v.recipientEmail.$invalid) {
        this.$emit('proceeedSendingTestEmail');
      }
    },

    async sendTestEmail(senderId, mailSubject, previewText, mailContent) {
      this.$emit('showLoader');
      try {
        const testMailPayload = {
          sender_id: senderId,
          subject: mailSubject,
          message: this.modifyEmailContent(mailContent),
          recipient_email: this.recipientEmail,
        };
        if (previewText) {
          testMailPayload.previewText = previewText;
        }
        await axios.post('/send-test-mail', testMailPayload)
          .then((response) => {
            this.initializeEmail();
            showAlert({
              iconType: 'alert-success',
              html: `
              <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
              <p class="text-lg font-bold text-deep-dark mb-3"> ${this.$t('frontend_groovemail_smtp_mail_sent_success_message')}</p>
              <p class="text-sm text-deep-dark"> ${response.data.message}</p>
            `,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonColor: themeConfig.appPrimaryColor,
              confirmButtonText: this.$t(
                'frontend_close'
              ),
            });
          }).catch((error) => {
            showAlert({
              iconType: 'alert-error',
              html: `
              <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
              <p class="text-sm text-deep-dark"> ${error.response.data.message}</p>
            `,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonColor: themeConfig.appPrimaryColor,
              confirmButtonText: this.$t(
                'frontend_close'
              ),
            });
          });

        this.$emit('hideLoader');
      } catch (e) {
        this.$emit('hideLoader');
      }
    },

    initializeEmail() {
      this.$v.recipientEmail.$reset();
      this.recipientEmail = '';
    },

    modifyEmailContent(emailContent) {
      let content = emailContent.replace(/<p>/g, '<p style="margin: 0px; padding-left: 5px; padding-right: 5px;">');
      content = content.replace(/<ul>/g, '<ul style="margin: 0px; padding-left: 40px; padding-right: 5px;">');
      content = content.replace(/<ol>/g, '<ol style="margin: 0px; padding-left: 40px; padding-right: 5px;">');
      return content;
    },
  },
};
</script>

<style lang="scss"></style>
